<template>
  <table class="task-tree width100p">
    <tbody>
      <tr v-for="item in linearizedTasks" :key="item.id">
        <td :style="{ paddingLeft: (item.level*20)+'px'}" class="task-tree-name-col">
          <span v-html="taskIconHtml(item)"></span> <a :href="taskEditUrl(item)" :class="nameClass(item)">{{ item.subject }}</a>
        </td>
        <td :class="deadlineClass(item)">{{ deadline(item) }}</td>
        <td class="fonts">
          <a :href="taskCustomerUrl(item)" v-if="hasParty(item)">{{ item.customerFileAs }}</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export const DATE_MONTH_FORMAT = new Intl.DateTimeFormat(undefined, {
  day:"numeric",
  month:"numeric"
});

export const FULL_DATE_FORMAT = new Intl.DateTimeFormat(undefined, {
  day:"numeric",
  month:"numeric",
  year:"2-digit",
  weekday:"short"
});

export default {
  name: "SubtasksView",
  data() {
    return {
      items: []
    }
  },
  computed: {
    linearizedTasks() {
      const lin = [];
      this.outputToArray(lin, this.items, 0);
      return lin;
    },
  },
  methods: {
    outputToArray(linearized, hierarchical, level) {
      for (let h of hierarchical) {
        h.level = level;
        linearized.push(h);
        if (h.subtasks) this.outputToArray(linearized, h.subtasks, level+1);
      }
    },
    taskEditUrl(task) {
      switch (task.srcType) {
        case 1:
          return "editTask.do?id="+task.id;
        case 2:
          return "editEvent.do?id="+task.id;
        case 6:
          return "editContact.do?id="+task.id;
      }
    },
    taskIcon(task) {
      switch (task.srcType) {
        case 1:	// task
          return task.project ? "project" : "task";
        case 6: // contact
          switch (task.type)	// contact type
          {
            case 1: return "call";
            case 2: return "fax";
            case 3: return "email";
            case 4: return "mail";
            case 5: return "meeting";
            default: return "communication";
          }
        case 2: // event
          return "event";
      }
    },
    taskIconHtml(task) {
      return Icon.fi(this.taskIcon(task));
    },
    mostRelevantParty(task) {
      if (task.person) return task.person;
      if (task.branch) return task.branch;
      return task.customer;
    },
    hasParty(task) {
      return this.mostRelevantParty(task) > 0;
    },
    taskCustomerUrl(task) {
      return "editParty.do?id=" + this.mostRelevantParty(task);
    },
    isCompleted(task) {
      if (task.srcType === 1 || task.srcType === 2) return !!task.completed;
      else return !!task.contacted;
    },
    nameClass(task) {
      let cls = [];
      if (this.isCompleted(task)) cls.push("task-tree-completed");
      return cls;
    },
    deadlineISO(task) {
      switch (task.srcType) {
        case 1:	// task
          return task.deadline;
        case 2: // event
          return task.start;
        case 6: // contact
          return task.planContact;
      }
      return null;
    },
    deadlineDate(task) {
      const iso = this.deadlineISO(task);
      if (iso) return new Date(iso);
      return null;
    },
    deadline(task) {
      const d = this.deadlineDate(task);
      if (d != null) {
        let frm;
        if (d.getFullYear() === new Date().getFullYear()) frm = DATE_MONTH_FORMAT;
        else frm = FULL_DATE_FORMAT;
        return frm.format(d).replace(" ", "");
      } else return "";
    },
    deadlineClass(task) {
      const cls = ['fonts'];
      const d = this.deadlineDate(task);
      if (d != null && d < new Date() && !this.isCompleted(task)) cls.push('task-tree-due');
      return cls;
    },
    loadData(taskId) {
      return fetch("./api/tasks/"+taskId+"/subtasks")
          .then(response => response.json())
          .then(children => {
            this.items.length = 0;
            this.items.splice(0, 0, ...children);
          })
          .catch(ex => {
            console.log("Error loading subtasks")
            console.log(ex);
          });
    }
  }
}
</script>

<style>
.task-tree > tbody > tr > td {
  height: 22px;
  line-height: 22px;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: baseline;
}
.task-tree-name-col .fi {
  width: 22px;
}
a.task-tree-completed {
  --link-fg: #777777;
  text-decoration: line-through;
  text-decoration-color: var(--green);
}
.task-tree-due {
  color: var(--red);
}
</style>
